export default "__VITE_ASSET__BSkNm0t___"